// Kind column icon+label for PatsPanel — CTSK-204 (UI parity with the
// External Clients Nest page). Mirrors ExternalClientsNest.tsx's Kind
// column (its CLIENT_KINDS table: Bot for Claude MCP sessions, Cpu for
// other MCP-role clients, Wrench for human-driven tools) using Lucide
// icon components rather than emoji glyphs. The ticket's brief describes
// the three kinds with emoji shorthand (🌐 / 🔧 / 🖥️), but true visual
// parity with the reference page means matching its actual icon
// vocabulary — which is Lucide components, not emoji, anywhere in that
// file. Judgment call, flagged in the CTSK-204 ship comment.
//
// `claude-mcp` vs `external-mcp` requires the PAT to be MCP-ROLE (has an
// `accessRequestDocId` — minted via the External Clients Nest
// approve-and-mint or change-client-role flow, CTSK-192). The split
// between the two is a sourceTag heuristic (see looksLikeClaudeSession in
// PatsPanel.tsx) because the PAT record doesn't carry the originating
// clientKind — only the access-request doc does, and threading that
// through would be a schema change (out of scope; this ticket is
// presentation-only per its non-goals).

import { Bot, Cpu, Monitor, type LucideIcon } from 'lucide-react';

export type PatKind = 'claude-mcp' | 'external-mcp' | 'hand-mint';

const KIND_META: Record<PatKind, { icon: LucideIcon; label: string }> = {
  'claude-mcp': { icon: Bot, label: 'Claude MCP' },
  'external-mcp': { icon: Cpu, label: 'External MCP' },
  'hand-mint': { icon: Monitor, label: 'Hand-mint' },
};

export function KindIcon({ kind }: { kind: PatKind }) {
  const meta = KIND_META[kind];
  const Icon = meta.icon;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12 }}>
      <Icon size={12} aria-hidden="true" />
      {meta.label}
    </span>
  );
}
